export class ConnectorGcpProjectProperties {
    'gcpProjectId';
    'discoveryServiceAccountName';
    'dataAccessServiceAccountName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpProjectId",
            "baseName": "gcpProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "discoveryServiceAccountName",
            "baseName": "discoveryServiceAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataAccessServiceAccountName",
            "baseName": "dataAccessServiceAccountName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectorGcpProjectProperties.attributeTypeMap;
    }
    constructor() {
    }
}
